var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useMemo } from 'react';
import onClickOutside from 'react-onclickoutside';
import { trackConfirmFilter, trackSelectFilter, trackViewFilter } from '@browsing/tracking';
import { find, findPath, getNodesSet } from './helpers';
import ContainerDesktop from './ContainerDesktop/ContainerDesktop';
import { MultipleCategorySelectMobile } from './multiple-category-select-mobile';
var FILTER_TAB_NONE = 'SHOW_NONE';
var CATEGORY_TAB_SELECTOR_ID = 'category-tab-selector';
export var CategoryList = function (_a) {
    var selectedCategories = _a.selectedCategories, campaign = _a.campaign, showCategoriesModal = _a.showCategoriesModal, setVisibilityFilter = _a.setVisibilityFilter, allCategories = _a.allCategories, availableCategories = _a.availableCategories, updateFilter = _a.updateFilter, totalArticlesCount = _a.totalArticlesCount, isResetHidden = _a.isResetHidden, isRootCategoryToggleDisabled = _a.isRootCategoryToggleDisabled, isCrossCampaign = _a.isCrossCampaign, isMyLoungeCrossCampaignEntry = _a.isMyLoungeCrossCampaignEntry, updateCategoriesFilter = _a.updateCategoriesFilter, preExpandedCategories = _a.preExpandedCategories, sharedGA4args = _a.sharedGA4args, showCompactTrigger = _a.showCompactTrigger, _b = _a.handleCloseMobileFilterDialog, handleCloseMobileFilterDialog = _b === void 0 ? function () { } : _b;
    useEffect(function () {
        trackViewFilter(__assign(__assign({}, sharedGA4args), { element: 'category_filter', filterLvl: showCategoriesModal ? 2 : 1, filtersValue: "".concat((selectedCategories === null || selectedCategories === void 0 ? void 0 : selectedCategories[0]) || '') }));
    }, []);
    var closeFilterModal = useCallback(function (shouldSave) { return setVisibilityFilter(FILTER_TAB_NONE, true, shouldSave); }, [setVisibilityFilter]);
    // @ts-ignore
    CategoryList.handleClickOutside = useCallback(function (e) {
        var categoryTabDom = document.getElementById(CATEGORY_TAB_SELECTOR_ID);
        if (categoryTabDom && categoryTabDom.contains(e.target)) {
            return;
        }
        closeFilterModal(false);
    }, []);
    var resetCategoryFilter = useCallback(function () {
        updateCategoriesFilter([]);
        closeFilterModal(false);
    }, []);
    var toggleSelection = useCallback(function (categoryId, depth, isExpanded) {
        if (isExpanded === void 0) { isExpanded = false; }
        var isRootCategory = categoryId === availableCategories.id;
        if (isRootCategoryToggleDisabled && isRootCategory) {
            return;
        }
        updateFilter({
            categories: [categoryId],
        });
        var selectedCategory = find(allCategories, categoryId);
        var filtersValue = (selectedCategory
            ? findPath(allCategories, selectedCategory).slice(0, -1).reverse()
            : []).join(';');
        trackSelectFilter(__assign(__assign({}, sharedGA4args), { element: 'category_filter', filterLvl: depth, filtersValue: filtersValue }));
        if (!showCategoriesModal) {
            var category = find(availableCategories, categoryId);
            var campaignId_1 = campaign === null || campaign === void 0 ? void 0 : campaign.campaignIdentifier;
            trackConfirmFilter(__assign(__assign({}, sharedGA4args), { element: 'category_filter', filterLvl: depth, filtersValue: filtersValue, length: (category === null || category === void 0 ? void 0 : category.count) || 0, campaignId: campaignId_1 }));
        }
    }, [availableCategories]);
    var availableCategoriesSet = useMemo(function () { return getNodesSet(availableCategories); }, [availableCategories]);
    var selectedCategoriesSet = useMemo(function () { return new Set(selectedCategories); }, [selectedCategories]);
    var selectedCategoryId = (selectedCategories === null || selectedCategories === void 0 ? void 0 : selectedCategories.length) > 0 ? selectedCategories[0] : null;
    var selectedCategory = selectedCategoryId ? find(allCategories, selectedCategoryId) : null;
    var selectedPath = selectedCategory ? findPath(allCategories, selectedCategory) : [];
    var campaignId = (campaign === null || campaign === void 0 ? void 0 : campaign.campaignIdentifier) || '';
    var onContainerMobileSave = function () {
        var selectedFilterPath = (selectedCategory ? findPath(allCategories, selectedCategory).slice(0, -1).reverse() : []).join(';');
        var sameLevelCategoryIds = selectedCategories.length <= 1
            ? ''
            : ",".concat(selectedCategories.slice(1, selectedCategories.length).join(','));
        var filtersValue = "".concat(selectedFilterPath).concat(sameLevelCategoryIds);
        closeFilterModal(true);
        handleCloseMobileFilterDialog();
        trackConfirmFilter(__assign(__assign({}, sharedGA4args), { element: 'category_filter', filterLvl: selectedPath.length <= 2 ? 1 : selectedPath.length - 1, filtersValue: filtersValue, length: totalArticlesCount }));
    };
    return showCategoriesModal ? (React.createElement(MultipleCategorySelectMobile, { allCategories: availableCategories, campaignId: campaignId, resetCategoryFilter: resetCategoryFilter, selectedCategoriesSet: selectedCategoriesSet, availableCategories: availableCategories, availableCategoriesSet: availableCategoriesSet, count: totalArticlesCount, isResetHidden: isResetHidden, onClose: function () { return closeFilterModal(false); }, onSave: onContainerMobileSave, isCrossCampaign: isCrossCampaign, isMyLoungeCrossCampaignEntry: isMyLoungeCrossCampaignEntry, updateCategoriesFilter: updateCategoriesFilter, preExpandedCategories: preExpandedCategories, sharedGA4args: sharedGA4args, showCompactTrigger: showCompactTrigger })) : (React.createElement(ContainerDesktop, { allCategories: availableCategories, campaignId: campaignId, toggleSelection: toggleSelection, selectedPath: selectedPath, selectedCategoriesSet: selectedCategoriesSet, availableCategoriesSet: availableCategoriesSet, closeFilterModal: function () {
            closeFilterModal(false);
        }, isCrossCampaign: isCrossCampaign }));
};
var clickOutsideConfig = {
    // @ts-ignore
    handleClickOutside: function () { return CategoryList.handleClickOutside; },
};
// @ts-ignore
export default onClickOutside(CategoryList, clickOutsideConfig);
